// extracted by mini-css-extract-plugin
module.exports = {"bxTextTruncateEnd":"Footer-module--bx--text-truncate--end--ASoCk","bxTextTruncateFront":"Footer-module--bx--text-truncate--front--xZ1AG","logo":"Footer-module--logo--irqK8"};